import '@babel/polyfill';
import '@codev/helix-bootstrap';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import window from './globalWrappers/window.js';
import initForgotPasswordView from './initForgotPasswordView.jsx';
import initResetPasswordView from './initResetPasswordView.jsx';

window.initForgotPasswordView = initForgotPasswordView;
window.initResetPasswordView = initResetPasswordView;
